// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let WizardFormUtils = require("../../common/Form/WizardFormUtils.bs.js");

function useIsValid(address, selectedArea, geocodingStatus) {
  let match = WizardFormUtils.noneIfEmpty(address);
  if (match === undefined) {
    return {
      NAME: "Invalid",
      VAL: "missingAddress"
    };
  }
  if (selectedArea === undefined) {
    return {
      NAME: "Invalid",
      VAL: "missingCity"
    };
  }
  switch (geocodingStatus) {
    case "NotCalled" :
    case "Called" :
      return;
    case "Valid" :
      return {
        NAME: "Valid",
        VAL: [
          match,
          selectedArea.label
        ]
      };
    case "Error" :
      return {
        NAME: "Invalid",
        VAL: "geocodingFailed"
      };
    case "ErrorDuplicateListing" :
    case "ErrorOutsideChapterBoundaries" :
      break;
  }
  if (geocodingStatus === "ErrorDuplicateListing") {
    return {
      NAME: "Invalid",
      VAL: "duplicateListing"
    };
  } else {
    return {
      NAME: "Invalid",
      VAL: "outsideChapterBoundaries"
    };
  }
}

let StreetAddress = {
  useIsValid: useIsValid
};

function useIsValid$1(selectedArea, geocodingStatus) {
  if (selectedArea === undefined) {
    if (geocodingStatus === "Called") {
      return;
    } else {
      return {
        NAME: "Error",
        VAL: "is required"
      };
    }
  }
  switch (geocodingStatus) {
    case "NotCalled" :
    case "Called" :
      return;
    case "Valid" :
      return "Valid";
    default:
      return {
        NAME: "Error",
        VAL: ""
      };
  }
}

let CityOrZip = {
  useIsValid: useIsValid$1
};

exports.StreetAddress = StreetAddress;
exports.CityOrZip = CityOrZip;
/* WizardFormUtils Not a pure module */
